// Packages
import Vue from 'vue';
import smoothscroll from 'smoothscroll-polyfill';

// Core
import '~scripts/core/goTo';

// Blocks
import '~scripts/blocks/cookie-alert';
import '~scripts/blocks/cookie-alert-ai';

// Components
import '~scripts/components/forms/radios';
import '~scripts/components/forms/selects';

// Safari doesn't support {behavior: 'smooth'} option of scrollIntoView/scrollTo
smoothscroll.polyfill();

//
// DEMO REQUEST MODAL
//
document.addEventListener('open-modal', (e) => {
  const { id } = e.target;

  if (id === 'demoRequestModal') {
    window.openDemoRequestModal();
  }
});

//
// FORM SUCCESS MESSAGE
//
import FormSuccessMessage from '~scripts/blocks/vue/FormSuccessMessage.vue';

if (document.querySelector('.form-success-message')) {
  let successComponents = document.querySelectorAll('.form-success-message');

  successComponents.forEach((item) => {
    new Vue({
      el: item,
      name: 'FormSuccessMessage',
      components: {
        FormSuccessMessage,
      },
    });
  });
}

//
// SLYSH KUPI
//
import SlyshKupi from '~scripts/blocks/vue/SlyshKupi.vue';

if (document.getElementById('VSlyshKupi')) {
  new Vue({
    el: '#VSlyshKupi',
    name: 'VSlyshKupi',
    components: {
      SlyshKupi,
    },
  });
}
